import { createFileRoute } from "@tanstack/react-router";
import { BackupsPage } from "@/components/admin/BackupsPage";

export const Route = createFileRoute("/_authenticated/admin/backups")({
  component: BackupsPage,
});
